export const CLE_ORG_OR_CLUB_ID = 1;
